import { useCallback, useEffect, useRef, useState } from "react";

import { useAccessToken } from "../../contexts/AccessTokenContext";

export const useDashboardSection = (
  fetcher,
  adapter,
  { year, dateRange, warehouse, month, day, companyCode, period }
) => {
  const { accessToken } = useAccessToken();
  const [data, setData] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [updatedAt, setUpdatedAt] = useState(null);
  const reqId = useRef(0);

  const start = dateRange?.[0];
  const end = dateRange?.[1];
  const warehouseId =
    warehouse && warehouse !== "all" && !Number.isNaN(Number(warehouse)) ? Number(warehouse) : undefined;

  const fetchData = useCallback(async () => {
    if (!accessToken) return;
    const myId = ++reqId.current;
    setFetching(true);
    setError(null);
    try {
      const res = await fetcher(accessToken, {
        year,
        month: month || undefined, // ส่งเฉพาะ section ที่ใส่ month มา (Summary) — section อื่น undefined → axios ไม่ส่ง
        day: day || undefined, // เช่นเดียวกับ month — คุมคอลัมน์แรก (Today) ของ Summary เท่านั้น
        start_date: start || undefined,
        end_date: end || undefined,
        warehouse_id: warehouseId,
        company_code: companyCode || undefined, // เฉพาะ drill-down ระดับลูกค้า — หน้าอื่นไม่ส่ง
        period: period || undefined, // เฉพาะหน้า drill-down (ช่วงที่กดมา) — dashboard ไม่ส่ง
      });
      if (myId !== reqId.current) return; // ถูก request ใหม่แทนที่แล้ว → ทิ้งผลนี้
      if (!res || res?.response?.status >= 400) {
        throw new Error("Failed to load dashboard section");
      }
      setData(adapter(res));
      setUpdatedAt(new Date());
    } catch (err) {
      if (myId !== reqId.current) return; // ทิ้ง error ของ request ที่ถูกแทนที่
      setError(err);
    } finally {
      if (myId === reqId.current) setFetching(false);
    }
  }, [accessToken, fetcher, adapter, year, month, day, start, end, warehouseId, companyCode, period]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // โหลดครั้งแรก (ยังไม่มีทั้ง data และ error) → ใช้แสดง skeleton
  const loading = fetching && data == null && error == null;

  return { data, loading, fetching, error, refetch: fetchData, updatedAt };
};
